/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamExam extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamExam';
    }

    data({
        examName,
        paperTemplateId,
        classExaminationType,
        examStatus,
        orderByKey,
        orderByType,
        schoolOrgId,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            examName,
            paperTemplateId,
            classExaminationType,
            examStatus,
            orderByKey,
            orderByType,
            schoolOrgId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    cancelExam({ id, cancelDesc }) {
        return super.post('/cancelExam', { id, cancelDesc });
    }

    save({
        id,
        classExaminationType,
        examName,
        paperTemplateId,
        examNum,
        examTime,
        examDesc,
        verticalGroupingListJson,
        schoolOrgId,
        recognitionType,
        recognitionQuestionNum,
    } = {}) {
        return super.post('/save', {
            id,
            classExaminationType,
            examName,
            paperTemplateId,
            examNum,
            examBeginTime: examTime[0],
            examEndTime: examTime[1],
            examDesc,
            verticalGroupingListJson,
            schoolOrgId,
            recognitionType,
            recognitionQuestionNum,
        });
    }

    certExamExamApplyList({
        fullName,
        idCardNo,
        mobile,
        userName,
        examName,
        certCatId,
        certExamType,
        verticalGroupingName,
        examResult,
        classExaminationType,
        examNotPassType,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    }) {
        return super.get('/certExamExamApplyList', {
            fullName,
            idCardNo,
            mobile,
            userName,
            examName,
            certCatId,
            certExamType,
            verticalGroupingName,
            examResult,
            classExaminationType,
            examNotPassType,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new CertExamExam();
export { CertExamExam };
